// Canonical origin. www.petsmartpuppies.com 301-redirects here, so every
// canonical, og:url, schema url and sitemap entry must use this host.
export const SITE = 'https://petsmartpuppies.com';

// Each route is prerendered to <route>/index.html, which Netlify serves at
// "/route/" (and 301-redirects "/route" there), so canonical URLs and internal
// links end in a slash.
export const canonicalFor = (path) => `${SITE}${path.replace(/\/+$/, '')}/`;
